var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen overflow-x-hidden font-sans antialiased bg-gray-50",attrs:{"id":"app"}},[_c('router-view',{key:_vm.account ? _vm.account.id : 'none'}),_c('portal-target',{attrs:{"name":"modals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }